export default "__VITE_ASSET__Cj3CdFow__"